/* eslint-disable eag/match-named-export */
import {createContext} from 'shared/web';

import {DataGridPermissionKeysEnum} from '../types/DataGridPermissionKeysEnum';
import {UserOptionsQuery} from '../types/UserOptionsQuery';
import {EntityResourceResolver} from './EntityResourceResolver';

export type StartedExport = {
  exportId: string;
  gridCode: string;
};

export type EagGridConfigProviderProps = {
  entityResourceResolver?: EntityResourceResolver;
  // agGridEnterpriseLicenseKey removed — EagGrid has no AG Grid dependency
  // function which returns absolute url for given share link, if it is not supplied, the share button will be hidden
  buildAbsoluteUrl?: (url: string) => string;
  useGetUserOptions?: () => UserOptionsQuery;
  usePermissions: (props: {permissionKeys: DataGridPermissionKeysEnum[]}) => boolean[];
  handleExportSuccessfullyStarted?: (startedExport: StartedExport) => void;
};

export const [EagGridConfigProvider, useEagGridConfig] = createContext<EagGridConfigProviderProps>({
  strict: true,
  name: 'EagGridConfigProvider',
});
